import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M13.422 10.578a3.111 3.111 0 0 0-4.4 0l-3.11 3.111a3.111 3.111 0 0 0 4.399 4.4l.857-.857m-.59-3.81a3.111 3.111 0 0 0 4.4 0l3.11-3.111a3.111 3.111 0 0 0-4.399-4.4l-.855.855",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render };